<template>
  <div class="list-preview" ref="listPreviewEl">
    <div class="list-item list-view" ref="listView">
      <div class="list-view-header" ref="listViewHeader">
        <slot name="list-view-header"></slot>
      </div>
      <div class="list-view-content" ref="listViewContent">
        <vue-scroll :ops="scrollBar">
          <slot name="list-view-content"></slot>
        </vue-scroll>
      </div>
      <div class="list-view-footer" ref="listViewFooter">
        <slot name="list-view-footer"></slot>
      </div>
    </div>
    <div class="preview animation" :style="previewStyle" ref="preview">
      <div class="box" ref="previewBox" :style="boxStyle">
        <div class="preview-header" ref="previewHeader">
          <slot name="preview-header"></slot>
        </div>
        <div class="preview-content" ref="previewContent">
          <vue-scroll
            :ops="scrollBar"
            v-if="(typeof this.previewNoScroll !== 'undefined') ? (this.previewNoScroll === true) ? true : false : true "
          >
            <slot name="preview-content"></slot>
          </vue-scroll>
          <slot name="preview-content" v-else></slot>
        </div>
        <div class="preview-footer" ref="previewFooter">
          <slot name="preview-footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "listPreview",
  components: {},
  computed: {
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    }
  },
  props: {
    previewWidth: Number,
    openOnLoad: Boolean,
    displayPreview: Boolean,
    previewNoScroll: Boolean
  },
  watch: {},
  data() {
    return {
      defaultWidth: 300,
      localWidth: 0,
      parentHeight: 0,
      boxStyle: {
        width: `0px`
      },
      previewStyle: {
        width: `0px`
      },
      resizeEvent: null,
      status: "close"
    };
  },
  mounted() {
    this.parentElement = this.$refs.listPreviewEl.parentElement;
    this.getParentChildren(this.parentElement.children);
    this.elementResize();
    this.resizeEvent = window.addEventListener("resize", () => {
      this.elementResize();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeEvent);
  },
  async created() {
    this.localWidth =
      typeof this.previewWidth === "undefined"
        ? defaultWidth
        : this.previewWidth;

    this.boxStyle.width = `${this.localWidth}px`;

    if (typeof this.openOnLoad !== "udefined" && this.openOnLoad) {
      this.status = "open";
      this.setPreviewWith(this.localWidth);
    }
  },
  methods: {
    elementResize() {
      // Get the height of the list preview element
      let listPreviewElHeight =
        this.$refs.listPreviewEl.parentElement.offsetHeight -
        this.$refs.listPreviewEl.offsetTop;
      // Set the height of all containers
      this.$refs.listPreviewEl.style.height = `${listPreviewElHeight}px`;
      this.$refs.listView.style.height = `${listPreviewElHeight}px`;
      this.$refs.preview.style.height = `${listPreviewElHeight}px`;
      // Get list header and footer height
      let listViewHeaderHeight = this.$refs.listViewHeader.offsetHeight;
      let listViewFooterHeight = this.$refs.listViewFooter.offsetHeight;
      // Get preview header and footer height
      let previewHeaderHeight = this.$refs.previewHeader.offsetHeight;
      let previewFooterHeight = this.$refs.previewFooter.offsetHeight;
      // Set preview box height
      this.boxStyle.height = `${listPreviewElHeight}px`;
      // Set the content height, this includes a js scroll bar
      this.$refs.previewContent.style.height = `${listPreviewElHeight -
        previewHeaderHeight -
        previewFooterHeight}px`;
      this.$refs.listViewContent.style.height = `${listPreviewElHeight -
        listViewHeaderHeight -
        listViewFooterHeight}px`;
      if (window.innerWidth < this.localWidth && this.status == "open") {
        this.setPreviewWith(window.innerWidth);
      } else if (this.status == "open") {
        this.setPreviewWith(this.localWidth);
      }
    },
    getParentChildren(children) {
      for (let key in children) {
        if (this.$refs.listPreviewEl !== children[key]) {
        }
      }
    },
    setPreviewWith(previewWidth) {
      if (typeof previewWidth !== "undefined") {
        this.previewStyle.width = `${previewWidth}px`;
        this.boxStyle.width = `${previewWidth}px`;
      } else {
        this.previewStyle.width = `${this.defaultWidth}px`;
        this.boxStyle.width = `${this.defaultWidth}px`;
      }
    },
    openPreview() {
      this.status = "open";

      if (window.innerWidth < this.localWidth) {
        this.setPreviewWith(window.innerWidth);
      } else {
        this.setPreviewWith(this.localWidth);
      }
    },
    closePreview() {
      this.status = "close";
      console.log("close");
      this.setPreviewWith(0);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.list-preview {
  height: 100%;
  display: flex;
  flex-direction: row;
  .animation {
    -webkit-transition: all 500ms ease;
    -moz-transition: all 500ms ease;
    -ms-transition: all 500ms ease;
    -o-transition: all 500ms ease;
    transition: all 500ms ease;
  }
  .list-item {
    height: 100%;
    flex-grow: 2;
    overflow: hidden;
    width: 0px;
  }
  .preview {
    height: 100%;
    border-left: solid 1px #f1f1f1;
    .box {
      height: 100%;
      .preview-content {
        height: 100%;
        .tabs,
        .tab-content,
        .tab-pane {
          height: 100%;
        }
      }
    }
    overflow: hidden;
    width: 0px;
  }
}
</style>
